import { Layout } from "../../../components/Layout";
import { Column, Grid, Row } from "carbon-components-react";
import { useLocation } from "react-router-dom";

export default function IntroductionContent() {
  const { pathname } = useLocation();

  return (
    <>
      <div className="doc-content">
        <h3 className="intro-title">Introduction</h3>
        <div className="icons pb-32">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="120"
            height="120"
            viewBox="0 0 120 120"
          >
            <g
              id="Group_6199"
              data-name="Group 6199"
              transform="translate(-1090 -227)"
            >
              <rect
                id="Rectangle_2262"
                data-name="Rectangle 2262"
                width="92"
                height="62"
                transform="translate(1102 246)"
                opacity="0.02"
              />
              <g
                id="Group_6198"
                data-name="Group 6198"
                transform="translate(1090 227)"
              >
                <g id="screen_1_" data-name="screen (1)">
                  <path
                    id="Path_6082"
                    data-name="Path 6082"
                    d="M97.888,4H9.376A7.372,7.372,0,0,0,2,11.368V70.31a7.372,7.372,0,0,0,7.376,7.368h29.5V92.413H24.128v7.368H83.136V92.413H68.384V77.678h29.5a7.372,7.372,0,0,0,7.376-7.368V11.368A7.372,7.372,0,0,0,97.888,4ZM61.008,92.413H46.256V77.678H61.008Zm36.88-22.1H9.376V11.368H97.888Z"
                    transform="translate(3.986 9.469)"
                    fill="#e0e0e0"
                  />
                  <rect
                    id="_Transparent_Rectangle_"
                    data-name="&lt;Transparent Rectangle&gt;"
                    width="120"
                    height="120"
                    fill="none"
                  />
                </g>
              </g>
              <path
                id="Path_6088"
                data-name="Path 6088"
                d="M14.739,38.978,8.878,43.862l5.861,4.884A1.9,1.9,0,1,1,12.3,51.672L4.686,45.325a1.9,1.9,0,0,1,0-2.926L12.3,36.052a1.9,1.9,0,1,1,2.437,2.926ZM42.665,42.4l-7.616-6.347a1.9,1.9,0,1,0-2.437,2.926l5.861,4.884-5.861,4.884a1.9,1.9,0,1,0,2.437,2.926l7.616-6.347a1.9,1.9,0,0,0,0-2.926ZM29.4,28.109a1.9,1.9,0,0,0-2.44,1.139L16.808,57.175a1.9,1.9,0,0,0,1.139,2.439,1.87,1.87,0,0,0,.651.116,1.9,1.9,0,0,0,1.79-1.254L30.543,30.55A1.9,1.9,0,0,0,29.4,28.109Z"
                transform="translate(1123.942 233.641)"
                fill="#ea3f66"
                opacity="0.802"
              />
            </g>
          </svg>
        </div>
        <p className="text pb-16 intro-text">
          This document describes TXPG REST API (hereinafter, REST API) used for
          interaction of external systems, in particular, merchant systems and
          terminals, with the TranzWare/TranzAxis e-Commerce Payment Gateway
          software product (hereinafter, TXPG). <br/><br/>The document describes the
          general principles of operation with TXPG REST API and standard
          scenarios of interaction with TXPG via API.

          <div className="line"></div>
        </p>
        
        <p  className="hint pt-16">This document provides manual for Merchants support personnel.</p>
      </div>
    </>
  );
}
